<script setup lang="ts">

const partners = [
  {
    id: "yachtpool",
    link: '/partners/yachtpool',
    image: new URL("@/assets/partners/page/yachtpool_2026.png", import.meta.url).href,
  },
  {
    id: "sealogy",
    link: '/partners/sealogy',
    image: new URL("@/assets/partners/page/sealogy.jpg", import.meta.url).href,
  },
]

</script>


<template>
  <div class="flex items-center mt-4 sm:mt-16 space-x-6">
    <div
        v-for="partner in partners"
        :key="partner.id"
        :id="partner.id"
        class="flex items-end"
    >
      <RouterLink :to="`/${$i18n.locale}${partner.link}`">
        <img
            :src="partner.image"
            :alt="partner.id"
            class="h-21 sm:h-25 w-auto max-w-full object-contain"
        />
      </RouterLink>
    </div>
  </div>
</template>
